import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { BiTrackParams } from '../../types';
import type { BiTrackApi } from '../bi-track-api';

@injectable()
export class BiTrackApiImpl extends PsHttpService implements BiTrackApi {
  get options() {
    const baseURL = (typeof import.meta !== 'undefined' && import.meta.env)
      ? import.meta.env.VITE_EUREKA_SERVICE_URI
      : process.env.VUE_APP_EUREKA_SERVICE_URI;
    return {
      baseURL: `${baseURL}/eureka`,
      headers: {
        'X-API-Version': '1.0',
      },
    };
  }

  biTrack(dataTrack: BiTrackParams) {
    return this.post<PatSnapCommonResponseData<boolean>>({
      url: '/tracking/add',
      data: dataTrack,
    }).then((res) => {
      return res.status as boolean;
    });
  }
}
